import React from 'react'
import { DialogContentText, LinearProgress, MenuItem, Select } from '@mui/material'
import { ShareEntity } from 'types/ShareEntity'

export const ChooseShare = ({
    shares,
    share,
    setShare,
}: {
    shares: Array<ShareEntity> | null
    share: ShareEntity | null
    setShare: (s: ShareEntity | string) => void
}) => {
    if (!shares) {
        return (
            <DialogContentText>
                Aktie: <LinearProgress />
            </DialogContentText>
        )
    }
    if (shares.length === 0) {
        return (
            <DialogContentText>
                Aktie: <i>Inga aktier hittades</i>
            </DialogContentText>
        )
    }
    if (shares.length === 1) {
        setShare(shares[0])
        return <DialogContentText>Aktie: {shares[0].name}</DialogContentText>
    }
    return (
        <Select onChange={(e) => setShare(e.target.value)} value={share ? share : ''} displayEmpty variant='outlined'>
            <MenuItem value='' disabled>
                Välj aktie
            </MenuItem>
            {shares.map((sh) => (
                <MenuItem key={sh.id} value={sh}>
                    {sh.name}
                </MenuItem>
            ))}
        </Select>
    )
}
